/**
 * Date Heading
 * Renders a formatted date heading for a group of schedule items.
 */

import { DateWithWeekday } from "./DateWithWeekday";

interface DateHeadingProps {
  date: string | null;
}

/** Renders a formatted date as a section heading, or nothing if date is null */
export function DateHeading({ date }: DateHeadingProps) {
  if (!date) return null;
  return (
    <h3 className="text-sm font-medium text-[color:var(--lp-text,#374151)]">
      <DateWithWeekday date={date} />
    </h3>
  );
}
